import { ContentType, request } from "../api";
import { baseParams } from "../common";

// Заявка на возврат от гостя: b2c ищет заказ по номеру и email плательщика (POST /application-refund).
// Тело — multipart: файл заявления + поля формы (reason, phone, requisites).
export const applicationRefund = async (data = {}, params = {}) =>
  request({
    path: "/application-refund",
    method: "POST",
    body: { ...baseParams, ...data },
    type: ContentType.FormData,
    format: "json",
    ...params,
  });

// Заявка на возврат авторизованного клиента: заказ должен принадлежать клиенту (POST /user-application-refund).
export const userApplicationRefund = async (data = {}, params = {}) =>
  request({
    path: "/user-application-refund",
    method: "POST",
    secure: true,
    body: { ...baseParams, ...data },
    type: ContentType.FormData,
    format: "json",
    ...params,
  });
